package com.yogaaicoach.common.analytics

// Binds to window.trackPageView, defined in jsMain/resources/index.html — see the comment there
// for why hash routes need an explicit page_view. It is a no-op until GA loads, and forever if
// cookies are declined or we're on localhost, so callers never check consent state themselves.
private external fun trackPageView(path: String, title: String)

// "#update-training-age-group" -> "/update-training-age-group" + "Update Training Age Group".
// Derived rather than mapped so routes added later report without touching this file; the empty
// route is the only one that needs help, since it renders either the login or the dashboard.
internal fun trackRouteView(route: String, isLoggedIn: Boolean) {
    val slug = route.removePrefix("#")
    if (slug.isEmpty()) {
        trackPageView("/", if (isLoggedIn) "Dashboard" else "Sign In")
    } else {
        val title = slug.split("-").joinToString(" ") { word -> word.replaceFirstChar { it.uppercase() } }
        trackPageView("/$slug", title)
    }
}
